var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp"},[_c('h1',{staticClass:"main-title"},[_vm._v("time-sensitive")]),_c('p',{staticClass:"subtitle-title"},[_vm._v("Stay on top of time.")]),_c('div',{staticClass:"lines"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"})])])
}]

export { render, staticRenderFns }